import { gqlFetcher } from './gqlFetcher';

/**
 * Обмен одноразового кода входа на сессионный токен.
 *
 * Схема `src/schema.graphql` ведётся руками, поэтому запрос отправляется строкой: gql.tada
 * типизирует по локальной схеме, а новая мутация попадёт в неё только после сверки с сервером.
 */
export const exchangeNativeLoginCode = async (
  code: string,
  verifier: string
): Promise<{ token: string; newUser: boolean } | null> => {
  const data = await gqlFetcher<{
    oauth: { nativeExchange: { token: string | null; newUser: boolean | null } | null };
  }>(
    `mutation NativeExchange($code: String!, $verifier: String!) {
      oauth { nativeExchange(code: $code, verifier: $verifier) { token newUser } }
    }`,
    { code, verifier }
  );
  const result = data?.oauth?.nativeExchange;
  return result?.token ? { token: result.token, newUser: Boolean(result.newUser) } : null;
};
